<template>
  <div class="container my-4">
    <router-link :to="{ name: 'ConfigurationsView', query: { deviceName: encodeURI(this.deviceName) } }">
      <fa-icon :icon="['fas', 'chevron-left']" class="mr-2" />{{ deviceName }} Konfigurationen
    </router-link>
    <h4 class="mt-3 mb-4">Neue {{ deviceName }} Konfiguration erstellen</h4>
    <form v-on:submit.prevent="speichereKonfiguration">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="font-weight-bold">Bezeichnung</label>
            <input type="text" class="form-control" v-model="name" placeholder="Apple iMac 5K 68,6cm(27&quot;) CTO">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Hersteller-Artikelnummer</label>
            <input type="text" class="form-control" v-model="herstellernummer" placeholder="MRR12D/A">
          </div>


          <div class="form-group">
            <label class="font-weight-bold">Artikel-Nr. Standardkonfiguration</label>
            <input type="text" class="form-control" v-model="artikelNrStandardkonfig" placeholder="PWAN-99513" />
          </div>

          <div class="form-group">
            <UploadImageComponent :configurationId="generiereId(16)" v-on:imageUpload="imageUpload" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Sichtbarkeit</label>
            <b-form-checkbox v-model="visibility.comlineshop">
              ComLine Shop
            </b-form-checkbox>
            <b-form-checkbox v-model="visibility.clrent">
              CLRent
            </b-form-checkbox>
            <b-form-checkbox v-model="visibility.ctoAtWebAndStore">
              CTO@Web/-Store
            </b-form-checkbox>
            <b-form-checkbox v-model="visibility.debug">
              <b>DEBUG</b>
            </b-form-checkbox>
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Status</label>
            <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select>
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Artikelnummer Präfix</label>
            <input type="text" class="form-control" v-model="artikelnummerPraefix" placeholder="C">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Produktcode</label>
            <input type="text" class="form-control" v-model="code" placeholder="Z0VT">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Datenblatt-Dateiname</label>
            <input type="text" class="form-control" v-model="datenblatt" placeholder="iMac_03-2019.pdf">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Deluxe-Warengruppe</label>
            <input type="text" class="form-control" v-model="warengruppe" placeholder="Apple CPU CTO iMac STD">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">UVP-Netto ohne UHG (&euro;)</label>
            <input type="number" class="form-control" step="0.01" v-model.number="dac">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">UHG (&euro;)</label>
            <input type="number" class="form-control" step="0.01" v-model.number="uhg">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">UVP-Brutto (&euro;)</label>
            <input type="number" class="form-control" step="0.01" v-model.number="uvpBrutto">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Skonto R1 (%)</label>
            <input type="number" class="form-control" step="0.01" v-model.number="skontoR1">
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Deluxe-Beschreibungstext</label>
            <textarea class="form-control" rows="5" v-model="deluxeBeschreibungstext"></textarea>
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Shop-Beschreibungstext</label>
            <textarea class="form-control" rows="12" v-model="shopBeschreibungstext"></textarea>
          </div>

        </div>
      </div>

      <b-form-group>
        <b-card class="shadow-sm">
          <label class="font-weight-bold mb-3">Komponenten</label>
          <draggable-component :group="'komponenten'" :itemName="'name'" :availableItems="verfuegbareKomponenten"
            :selectedItems="gewaehlteKomponenten" :availableItemsHeading="'Verfügbare Komponenten'"
            :selectedItemsHeading="'Gewählte Komponenten'">
          </draggable-component>
        </b-card>
      </b-form-group>

      <button type="submit" class="btn btn-primary">Speichern</button>
    </form>
  </div>
</template>

<script>
import UploadImageComponent from '../components/UploadImageComponent'
import draggableComponent from '../components/DraggableComponent'

import { firestore } from "../plugins/firebase"
import { collection, getDocs, query, orderBy, addDoc } from "firebase/firestore"

export default {
  name: 'CreateConfigurationView',
  components: {
    UploadImageComponent,
    draggableComponent
  },
  computed: {
    deviceName: function () {
      return decodeURI(this.$route.query.deviceName)
    },
    deviceId: function () {
      return this.$route.params.deviceId
    }
  },
  watch: {
    $data: {
      handler: function (data) {
        this.$store.commit('saveConfigurationTempData', data)
      },
      deep: true
    }
  },
  mounted() {
    this.ladeKomponenten()
    if (Object.keys(this.$store.state.configurationTempData).length !== 0) {
      this.visibility = this.$store.state.configurationTempData.visibility
      this.selectedStatus = this.$store.state.configurationTempData.selectedStatus
      this.bild = this.$store.state.configurationTempData.bild
      this.name = this.$store.state.configurationTempData.name
      this.artikelnummerPraefix = this.$store.state.configurationTempData.artikelnummerPraefix
      this.code = this.$store.state.configurationTempData.code
      this.dac = this.$store.state.configurationTempData.dac
      this.datenblatt = this.$store.state.configurationTempData.datenblatt
      this.herstellernummer = this.$store.state.configurationTempData.herstellernummer
      this.artikelNrStandardkonfig = this.$store.state.configurationTempData.artikelNrStandardkonfig
      this.skontoR1 = this.$store.state.configurationTempData.skontoR1
      this.uhg = this.$store.state.configurationTempData.uhg
      this.uvpBrutto = this.$store.state.configurationTempData.uvpBrutto
      this.warengruppe = this.$store.state.configurationTempData.warengruppe
      this.deluxeBeschreibungstext = this.$store.state.configurationTempData.deluxeBeschreibungstext
      this.shopBeschreibungstext = this.$store.state.configurationTempData.shopBeschreibungstext
      this.gewaehlteKomponenten = this.$store.state.configurationTempData.gewaehlteKomponenten
    }
  },
  methods: {
    imageUpload: function (url) {
      this.bild = url
    },
    generiereId: function (idLength) {
      const alphaNum = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let id = ''
      for (let i = 0; i < idLength; i++) {
        id += alphaNum.charAt(Math.floor(Math.random() * alphaNum.length))
      }
      return id
    },
    ladeKomponenten: function () {
      const q = query(collection(firestore, 'komponenten'), orderBy("name", "asc"))

      getDocs(q)
        .then((d) => {
          d.forEach(document => {
            const element = {
              id: document.id,
              data: document.data()
            }
            this.verfuegbareKomponenten.push(element)
          })
            .catch(error => console.error(error)) // eslint-disable-line no-console
        })
    },
    speichereKonfiguration: function () {

      addDoc(collection(firestore, 'konfigurationen'), {
        visibility: this.visibility,
        selectedStatus: this.selectedStatus,
        orderIndex: this.orderIndex,
        bild: this.bild,
        name: this.name.trim().replace(/[‘´'´]+/g, '"'),
        artikelnummerPraefix: this.artikelnummerPraefix,
        code: this.code,
        dac: this.dac,
        deviceId: this.deviceId,
        datenblatt: this.datenblatt,
        herstellernummer: this.herstellernummer,
        artikelNrStandardkonfig: this.artikelNrStandardkonfig,
        skontoR1: this.skontoR1,
        uhg: this.uhg,
        uvpBrutto: this.uvpBrutto,
        warengruppe: this.warengruppe,
        deluxeBeschreibungstext: this.deluxeBeschreibungstext,
        shopBeschreibungstext: this.shopBeschreibungstext,
        gewaehlteKomponenten: this.gewaehlteKomponenten
      })
        .then(() => this.$router.push({
          name: 'ConfigurationsView',
          query: {
            deviceName: encodeURI(this.deviceName)
          }
        }))
        .catch(error => console.error(error)) // eslint-disable-line no-console
    }
  },
  data() {
    return {
      orderIndex: 99,
      name: '',
      artikelnummerPraefix: 'C',
      code: '',
      dac: 0,
      datenblatt: '',
      herstellernummer: '',
      artikelNrStandardkonfig: '',
      skontoR1: 0.3,
      uhg: 0,
      uvpBrutto: 0,
      warengruppe: '',
      deluxeBeschreibungstext: 'CTO Variante der Grundkonfiguration [SPEZIFIKATIONEN] ##Urheberrechtsabgabe nach §54a UrhG abgeführt und im Kaufpreis enthalten - Artikel auftragsbezogen bestellt, Stornierung oder Rückgabe ausgeschlossen - We can not accept a cancellation or return for this build to order configuration.',
      shopBeschreibungstext: '<b>Apple CTO Rechner werden im Kundenauftrag bestellt und gefertigt. Nach erfolgtem Auftragseingang können diese CTO Rechner nicht mehr storniert werden und sind somit von der Rückgabe ausgeschlossen. Apple CTO computers are ordered and assembled on customers demand. After reciept of order CTO computers can not be canceled and are thereby excluded from return.<br><br>Spezifikationen:</b> [SPEZIFIKATIONEN] <br><br>- Urheberrechtsabgabe nach §54a UrhG abgeführt und im Kaufpreis enthalten - Artikel auftragsbezogen bestellt, Stornierung oder Rückgabe ausgeschlossen - We can not accept a cancellation or return for this build to order configuration.',
      gewaehlteKomponenten: [],
      verfuegbareKomponenten: [],
      selectedStatus: 'neu',
      bild: '',
      statusOptions: [
        {
          value: "",
          text: "-",
        },
        {
          value: "in-kuerze-verfuegbar",
          text: "In Kürze verfügbar",
        },
        {
          value: "wartung",
          text: "In Wartung",
        },
        {
          value: "neu",
          text: "Neu",
        },
      ],
      visibility: {
        comlineshop: false,
        clrent: false,
        ctoAtWebAndStore: false,
        debug: true
      }
    }
  },
}
</script>

<style scoped>
.dropzone {
  border: 1px dashed #ced4da;
}

.dropzone .card {
  cursor: move;
}
</style>